import React, { Component, PropTypes } from "react"
import { connect } from 'react-redux'
import ReactCSSTransitionGroup from "react-addons-css-transition-group"
import { sortBy } from "lodash"
import UserPanel from "./userPanel"
import { approveSession, changeProgram, hideSession, putOnHold } from 'actions/paywallActions'
import SessionList from 'views/staff/sessionList'

function toList(hash, keyProp) {
  return Object.keys(hash).map(k => ({...hash[k], [keyProp]: k}));
}

function groupBy(list, key, action) {
  const result = {};
  for (const item of list) {
    const groupValue = item[key];
    const group = (result[groupValue] = result[groupValue] || []);
    group.push(item);
  }
  if (action) {
    for (const k of Object.keys(result)) {
      result[k] = action(result[k]);
    }
  }
  return result;
}

function keepFirstOfEach(list, key) {
  const hasOne = {};
  return list.filter(x => {
    const value = x[key];
    if (hasOne[value]) return false;
    hasOne[value] = true;
    return true;
  })
}

class UsersByDate extends Component {

  static propTypes = {
    sessionType: PropTypes.string.isRequired,
    unapprovedSessions: PropTypes.object.isRequired,
    onHoldSessions: PropTypes.object.isRequired,
    profiles: PropTypes.object.isRequired,
    approveSession: PropTypes.func.isRequired,
    hideSession: PropTypes.func.isRequired,
    putOnHold: PropTypes.func.isRequired,
    changeProgram: PropTypes.func.isRequired
  };

  state = {
    unapprovedSessions: {},
    onHoldSessions: {},
    sortedUsers: []
  };

  componentDidUpdate (prevProps) {
    const { unapprovedSessions, onHoldSessions, sessionType } = this.props;
    if ((unapprovedSessions !== prevProps.unapprovedSessions || sessionType !== prevProps.sessionType) && sessionType === 'unapproved') {
      const sessionList = toList(unapprovedSessions, 'sessionId');
      const sortedList = sortBy(sessionList, 'createdAt');
      const sortedUsers = keepFirstOfEach(sortedList, 'userId').map(({userId}) => ({userId}));
      this.setState({
        unapprovedSessions: groupBy(sortedList, 'userId'),
        sortedUsers
      })
    }
    else if ((onHoldSessions !== prevProps.onHoldSessions || sessionType !== prevProps.sessionType) && sessionType === 'on hold') {
      const sessionList = toList(onHoldSessions, 'sessionId');
      const sortedList = sortBy(sessionList, 'createdAt');
      const sortedUsers = keepFirstOfEach(sortedList, 'userId').map(({userId}) => ({userId}));
      this.setState({
        onHoldSessions: groupBy(sortedList, 'userId'),
        sortedUsers
      })
    }
  }

  getChildren(sessionType, userId) {
    const { unapprovedSessions, onHoldSessions } = this.state;
    const { approveSession, hideSession, putOnHold, changeProgram, profiles } = this.props;
    const { email } = profiles[userId] || {};
    if (sessionType === 'unapproved') {
      return (
        <SessionList
          title={"Unapproved Classroom Sessions"}
          userId={userId}
          email={email}
          sessions={unapprovedSessions[userId]}
          approveSession={approveSession}
          hideSession={hideSession}
          putOnHold={putOnHold}
          changeProgram={changeProgram}
        />
      );
    }
    if (sessionType === 'on hold') {
      return (
        <SessionList
          title={"On Hold Classroom Sessions"}
          userId={userId}
          email={email}
          sessions={onHoldSessions[userId]}
          approveSession={approveSession}
          hideSession={hideSession}
          putOnHold={putOnHold}
          changeProgram={changeProgram}
        />
      );
    }
  }

  render () {
    const { sessionType, profiles } = this.props;
    const { unapprovedSessions, onHoldSessions, sortedUsers } = this.state;

    let sessions = 0;
    if (sessionType === 'unapproved' && unapprovedSessions) {
      sessions = Object.keys(unapprovedSessions).length;
    }
    else if (sessionType === 'on hold' && onHoldSessions) {
      sessions = Object.keys(onHoldSessions).length;
    }

    return (
      <div>
        { !sessions &&
          <p>No {sessionType} classroom sessions</p>
        }
        <ReactCSSTransitionGroup
            transitionName="unapproved-users-list"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={1000}>
          {
            sortedUsers.map(user => {
              const { userId } = user;
              return (
                <UserPanel
                  key={userId}
                  userId={userId}
                  profile={profiles[userId]}
                >
                  {this.getChildren(sessionType, userId)}
                </UserPanel>
              )
            })
          }
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default connect(
  ({paywall}) => ({
    profiles: paywall.profiles,
    unapprovedSessions: paywall.unapprovedSessions,
    onHoldSessions: paywall.onHoldSessions
  }),
  {
    approveSession,
    hideSession,
    putOnHold,
    changeProgram
  }
)(UsersByDate);



// WEBPACK FOOTER //
// ./src/views/staff/usersByDate.jsx